<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// Universal RAW to PNG converter - supports 20+ camera RAW formats via LibRaw
const converterConfig = parseAndValidateConverterConfig('raw-to-png-converter', 'RAW → PNG');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[RAW to PNG Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[RAW to PNG Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[RAW to PNG Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[RAW to PNG Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[RAW to PNG Converter] Credits updated:', credits);
}
</script>
